/* global analytics */
import R from 'ramda'

import folders from './modules/folders'
import studentOnboarding from './modules/studentOnboarding'
import print from './modules/print'

// Add your app/feature's module here:
const modules = [folders, studentOnboarding, print]

// For a given module, convert its values into functions.
// Each function returns analytics.track() using the value as the event name;
// properties, options, and a callback may be optionally passed to this function.
const mapModuleValues = eventValue => (
  properties = {},
  options = {},
  callback = null
) => analytics.track(eventValue, properties, options, callback)

// Track is an object whose keys are the keys from every module,
// and whose values are the functions created by mapModuleValues
const track = modules.reduce(
  (trackObj, module) => ({
    ...trackObj,
    ...R.map(mapModuleValues, module),
  }),
  {}
)

export default track
